import type { ContraceptionState } from "./ContraceptionContext";

export type ContraceptionFlowRoute =
  | "ContraceptionMethods"
  | "ContraceptionDetails"
  | "ContraceptionComplete";

export function buildContraceptionNavigationStack(
  state: ContraceptionState,
): ContraceptionFlowRoute[] {
  const stack: ContraceptionFlowRoute[] = ["ContraceptionMethods"];

  if (state.usesContraception === true && state.contraceptions.length > 0) {
    stack.push("ContraceptionDetails");
  }

  stack.push("ContraceptionComplete");

  return stack;
}
